<template>
  <list-item
    class="employee-list-item"
    :card="employee"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #image>
      <index-image :index="employee" />
    </template>

    <template #info>
      <align class="employee-list-item-info" flex>
        <div class="label">
          {{ employee.label }}
        </div>
      </align>
    </template>
  </list-item>
</template>

<script>
import ListItem from '@cardladder/shared/components/ListItem';
import IndexImage from '@cardladder/shared/components/IndexImage';

export default {
  components: {
    ListItem,
    IndexImage,
  },

  props: {
    employee: Object,
  },
};
</script>

<style lang="scss" scoped>
.label {
  @include ellipsis;
  font-size: 22px;
  font-weight: bold;
}

.employee-list-item-info {
  flex: 1;
}
</style>
